(() => {
  const defaultMessages = {
    offer: 'المرجو اختيار عرض قبل تأكيد الطلب.',
    changeOffer: 'تغيير العرض',
    selectedOffer: 'العرض المختار',
    offerPrice: 'ثمن العرض',
    required: 'المرجو ملء هذا الحقل.',
    phone: 'المرجو إدخال رقم هاتف صحيح.',
    email: 'المرجو إدخال بريد إلكتروني صحيح.',
    previewOnly: 'هذه معاينة فقط، لم يتم إرسال أو تسجيل أي طلب.',
    endpointMissing: 'رابط تسجيل الطلب غير مفعّل حاليا. المرجو المحاولة لاحقا.',
    submitError: 'تعذر تسجيل الطلب. المرجو المحاولة مرة أخرى.',
    loading: 'جاري الإرسال...',
    success:
      'Merci pour votre commande ! Votre commande a bien été enregistrée. L’équipe WEARSE vous contactera afin de confirmer les détails de votre commande et de la livraison.',
  };

  const parseJson = (node, fallback = {}) => {
    try {
      return node ? JSON.parse(node.textContent) : fallback;
    } catch (_error) {
      return fallback;
    }
  };

  const trim = (value) => String(value || '').trim();
  const isValidEmail = (value) => value === '' || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  const isValidPhone = (value) => /^[+\d\s().-]{6,}$/.test(trim(value));
  const campaignKeys = ['utm_source', 'utm_campaign', 'utm_content', 'utm_medium', 'fbclid'];

  const readCampaignData = () => {
    const params = new URLSearchParams(window.location.search);

    return campaignKeys.reduce((data, key) => {
      data[key] = params.get(key) || null;
      return data;
    }, {});
  };

  document.querySelectorAll('.wearse-lp-chaussures').forEach((root) => {
    const offers = parseJson(root.querySelector('[data-wearse-offers]'));
    const messages = {
      ...defaultMessages,
      ...parseJson(root.querySelector('[data-wearse-messages]')),
    };
    const form = root.querySelector('[data-wearse-order-form]');
    const summary = root.querySelector('[data-wearse-order-summary]');
    const formError = root.querySelector('[data-wearse-form-error]');
    const orderResult = root.querySelector('[data-wearse-order-result]');
    const submitButton = form?.querySelector('[type="submit"]');
    const offerCards = root.querySelectorAll('[data-wearse-offer-card]');
    const offerButtons = root.querySelectorAll('[data-wearse-offer-trigger]');
    const endpoint = trim(root.getAttribute('data-wearse-endpoint'));
    const thankYouUrl = trim(root.getAttribute('data-wearse-thank-you-url'));
    const language = root.getAttribute('data-wearse-language') || '';
    const landingPage = root.getAttribute('data-wearse-landing-page') || '';
    const hidden = {
      offerId: root.querySelector('[data-wearse-offer-id]'),
      quantity: root.querySelector('[data-wearse-offer-quantity]'),
      amount: root.querySelector('[data-wearse-offer-amount]'),
    };

    let selectedOffer = null;
    let isSubmitting = false;

    const getFields = () => Array.from(form?.querySelectorAll('[data-wearse-field]') || []);
    const getSheetName = () => 'offre-chaussures';

    const setError = (field, message = '') => {
      if (!field) {
        return;
      }

      const key = field.getAttribute('data-wearse-field');
      const error = root.querySelector(`[data-wearse-error-for="${key}"]`);

      if (message) {
        field.setAttribute('aria-invalid', 'true');
        if (error) {
          error.textContent = message;
          error.hidden = false;
        }
      } else {
        field.removeAttribute('aria-invalid');
        if (error) {
          error.textContent = '';
          error.hidden = true;
        }
      }
    };

    const setFormError = (message = '') => {
      if (!formError) {
        return;
      }

      formError.textContent = message;
      formError.hidden = !message;
    };

    const renderSummary = () => {
      if (!summary) {
        return;
      }

      if (!selectedOffer) {
        summary.innerHTML = `
          <p>${messages.offer}</p>
          <a href="#${root.querySelector('[data-wearse-offers-section]')?.id || 'offres'}" data-wearse-change-offer>${messages.changeOffer}</a>
        `;
        return;
      }

      summary.innerHTML = `
        <p>${messages.selectedOffer}: <strong>${selectedOffer.label}</strong></p>
        <p>${messages.offerPrice}: <strong>${selectedOffer.amount}</strong></p>
        <a href="#${root.querySelector('[data-wearse-offers-section]')?.id || 'offres'}" data-wearse-change-offer>${messages.changeOffer}</a>
      `;
    };

    const syncOfferFields = () => {
      if (!hidden.offerId || !hidden.quantity || !hidden.amount) {
        return;
      }

      hidden.offerId.value = selectedOffer?.id || '';
      hidden.quantity.value = selectedOffer ? String(selectedOffer.quantity) : '';
      hidden.amount.value = selectedOffer ? String(selectedOffer.amount_cents) : '';
    };

    const syncPairFields = () => {
      const showSecondPair = Number(selectedOffer?.quantity || 0) > 1;

      root.querySelectorAll('[data-wearse-pair="2"]').forEach((pair) => {
        pair.hidden = !showSecondPair;
        pair.querySelectorAll('input, select').forEach((field) => {
          field.disabled = !showSecondPair;
          field.required = showSecondPair;
          if (!showSecondPair) {
            setError(field);
          }
        });
      });
    };

    const setSelectedOffer = (offerId, focusForm = true) => {
      const offer = offers[offerId];

      if (!offer) {
        return;
      }

      selectedOffer = offer;
      root.classList.add('has-selected-offer');

      offerCards.forEach((card) => {
        const isSelected = card.getAttribute('data-wearse-offer-card') === offerId;
        const label = card.querySelector('[data-wearse-selected-label]');

        card.classList.toggle('is-selected', isSelected);
        card.toggleAttribute('aria-current', isSelected);

        if (label) {
          label.hidden = !isSelected;
        }
      });

      offerButtons.forEach((button) => {
        button.setAttribute('aria-pressed', String(button.getAttribute('data-offer-id') === offerId));
      });

      renderSummary();
      syncOfferFields();
      syncPairFields();
      setFormError('');

      if (focusForm) {
        const orderSection = root.querySelector('[data-wearse-order-section]');
        orderSection?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        window.setTimeout(() => {
          const firstField = form?.querySelector('[data-wearse-field]:not(:disabled)');
          firstField?.focus({ preventScroll: true });
        }, 350);
      }
    };

    const validate = () => {
      let firstInvalid = null;

      getFields().forEach((field) => setError(field));
      setFormError('');

      if (!selectedOffer) {
        setFormError(messages.offer);
        firstInvalid = root.querySelector('[data-wearse-offer-trigger]');
      }

      getFields().forEach((field) => {
        if (field.disabled) {
          return;
        }

        const key = field.getAttribute('data-wearse-field');
        const label = field.getAttribute('data-wearse-label') || messages.required;

        if (field.required && trim(field.value) === '') {
          setError(field, messages[key] || label);
          firstInvalid = firstInvalid || field;
          return;
        }

        if (field.type === 'tel' && trim(field.value) && !isValidPhone(field.value)) {
          setError(field, messages.phone);
          firstInvalid = firstInvalid || field;
          return;
        }

        if (field.type === 'email' && !isValidEmail(trim(field.value))) {
          setError(field, messages.email);
          firstInvalid = firstInvalid || field;
        }
      });

      if (firstInvalid) {
        firstInvalid.focus();
        return false;
      }

      return true;
    };

    const prepareOrderPayload = () => {
      if (!selectedOffer) {
        return null;
      }

      const payload = {
        sheet: getSheetName(),
        sheet_name: getSheetName(),
        worksheet: getSheetName(),
        tab_name: getSheetName(),
        submitted_at: new Date().toISOString(),
        language,
        locale: language,
        landing_page: landingPage,
        landing_page_url: window.location.href,
        source_url: window.location.href,
        payment_method: 'cash_on_delivery',
        offer_id: selectedOffer.id,
        offer_chosen: selectedOffer.label,
        offer_label: selectedOffer.label,
        number_of_pairs: selectedOffer.quantity,
        offer_quantity: selectedOffer.quantity,
        offer_amount_cents: selectedOffer.amount_cents,
        offer_amount_label: selectedOffer.amount,
        price: selectedOffer.amount,
        ...readCampaignData(),
      };

      getFields().forEach((field) => {
        if (field.disabled) {
          return;
        }

        const key = field.getAttribute('data-wearse-field');
        const value = trim(field.value);

        payload[key] = value || null;
      });

      payload.model = payload.pair_1_model || null;
      payload.size = payload.pair_1_size || null;
      payload.color = payload.pair_1_color || null;
      payload.time = payload.submitted_at;
      payload.nom = payload.last_name || null;
      payload.prenom = payload.first_name || null;
      payload.tel = payload.phone || null;
      payload.Ville = payload.city || null;
      payload['Adresse de livraison *'] = payload.address || null;
      payload['Modèle_N1'] = payload.pair_1_model || null;
      payload['Pointure_N1'] = payload.pair_1_size || null;
      payload['Modèle_N2'] = payload.pair_2_model || null;
      payload['Pointure_N2'] = payload.pair_2_size || null;
      payload.prix = payload.price || null;
      payload.offre = payload.offer_label || null;
      payload.shoes = [1, 2]
        .map((number) => ({
          number,
          product: 'Chaussures WEARSE Medical',
          model: payload[`pair_${number}_model`] || null,
          color: payload[`pair_${number}_color`] || null,
          size: payload[`pair_${number}_size`] || null,
        }))
        .filter((item) => item.model || item.color || item.size);
      payload.shoes_json = JSON.stringify(payload.shoes);

      return payload;
    };

    const submitOrder = async (payload) => {
      if (!endpoint) {
        return { ok: false, error: 'missing_endpoint' };
      }

      const response = await fetch(endpoint, {
        method: 'POST',
        mode: 'no-cors',
        headers: {
          'Content-Type': 'text/plain',
        },
        body: JSON.stringify(payload),
      });

      if (response.type === 'opaque') {
        return { ok: true };
      }

      if (!response.ok) {
        return { ok: false, status: response.status };
      }

      const body = await response.text();

      if (body) {
        try {
          const json = JSON.parse(body);
          if (json.success === false || json.ok === false) {
            return { ok: false };
          }
        } catch (_error) {
          // Non-JSON success responses are accepted when the HTTP status is OK.
        }
      }

      return { ok: true };
    };

    const redirectToThankYou = (payload) => {
      if (!thankYouUrl) {
        return false;
      }

      const url = new URL(thankYouUrl, window.location.origin);
      const currentParams = new URLSearchParams(window.location.search);
      const previewThemeId = currentParams.get('preview_theme_id');

      if (previewThemeId) {
        url.searchParams.set('preview_theme_id', previewThemeId);
      }

      url.searchParams.set('lp', payload.language || '');
      url.searchParams.set('offer', payload.offer_id || '');
      window.location.assign(url.toString());
      return true;
    };

    const trackLead = (payload) => {
      if (typeof window.fbq !== 'function') {
        return;
      }

      window.fbq('track', 'Lead', {
        content_name: payload.landing_page,
        content_category: 'landing_page',
        value: Number(payload.offer_amount_cents || 0) / 100,
        currency: 'MAD',
      });
    };

    const setSubmitting = (state) => {
      isSubmitting = state;

      if (!submitButton) {
        return;
      }

      if (!submitButton.dataset.originalText) {
        submitButton.dataset.originalText = trim(submitButton.textContent);
      }

      submitButton.disabled = state;
      submitButton.textContent = state ? messages.loading : submitButton.dataset.originalText;
    };

    offerButtons.forEach((button) => {
      button.addEventListener('click', () => {
        setSelectedOffer(button.getAttribute('data-offer-id'));
      });
    });

    root.addEventListener('click', (event) => {
      const changeOffer = event.target.closest('[data-wearse-change-offer]');

      if (!changeOffer) {
        return;
      }

      event.preventDefault();
      root.querySelector('[data-wearse-offers-section]')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    getFields().forEach((field) => {
      field.addEventListener('input', () => {
        setError(field);
        if (orderResult) {
          orderResult.hidden = true;
        }
      });

      field.addEventListener('change', () => {
        setError(field);
        if (orderResult) {
          orderResult.hidden = true;
        }
      });
    });

    form?.addEventListener('submit', async (event) => {
      event.preventDefault();

      if (isSubmitting) {
        return;
      }

      if (!validate()) {
        if (orderResult) {
          orderResult.hidden = true;
        }
        return;
      }

      const payload = prepareOrderPayload();

      if (!endpoint) {
        setFormError(messages.endpointMissing);
        if (orderResult) {
          orderResult.hidden = true;
        }
        return;
      }

      setSubmitting(true);

      try {
        const result = await submitOrder(payload);

        if (!result.ok) {
          setFormError(messages.submitError);
          if (orderResult) {
            orderResult.hidden = true;
          }
          return;
        }

        setFormError('');
        trackLead(payload);

        if (redirectToThankYou(payload)) {
          return;
        }

        if (orderResult) {
          orderResult.textContent = messages.success;
          orderResult.hidden = false;
          orderResult.focus?.();
        }
      } catch (_error) {
        setFormError(messages.submitError);
        if (orderResult) {
          orderResult.hidden = true;
        }
      } finally {
        setSubmitting(false);
      }
    });

    const defaultOffer = trim(root.getAttribute('data-wearse-default-offer'));
    if (defaultOffer && offers[defaultOffer]) {
      setSelectedOffer(defaultOffer, false);
    } else {
      renderSummary();
      syncOfferFields();
      syncPairFields();
    }
  });
})();
